import { render, staticRenderFns } from "./Concejo.vue?vue&type=template&id=d23be712&scoped=true&"
import script from "./Concejo.vue?vue&type=script&lang=ts&"
export * from "./Concejo.vue?vue&type=script&lang=ts&"
import style0 from "./Concejo.vue?vue&type=style&index=0&id=d23be712&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23be712",
  null
  
)

export default component.exports